export default "__VITE_ASSET__12004617__"